import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import MyofunctionalTherapy from './pages/MyofunctionalTherapy';
import SleepApneaAdults from './pages/SleepApneaAdults';
import SleepApneaChildren from './pages/SleepApneaChildren';
import TMJ from './pages/TMJ';
import Contact from './pages/Contact';

// Scroll to top component
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <ScrollToTop />

        <div className="flex flex-col min-h-screen font-sans bg-white selection:bg-primary/20">
          <Navbar />

          <main className="flex-grow">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/myofunctional-therapy" element={<MyofunctionalTherapy />} />
              <Route path="/sleep-apnea-adults" element={<SleepApneaAdults />} />
              <Route path="/sleep-apnea-children" element={<SleepApneaChildren />} />
              <Route path="/tmj-treatment" element={<TMJ />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
          </main>

          <Footer />
        </div>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;